<template>
  <v-form ref="form" v-model="valid" lazy-validation @input="validate">
    <v-container>
      <v-row>
        <v-col cols="12" md="4" offset-md="2">
          <v-text-field
            class="text-uppercase"
            v-model="address.firstName"
            :rules="requiredAndLength"
            :counter="100"
            :label="text.fields.address.firstName"
            required
          ></v-text-field>
        </v-col>

        <v-col cols="12" md="4">
          <v-text-field
            class="text-uppercase"
            v-model="address.lastName"
            :rules="requiredAndLength"
            :counter="100"
            :label="text.fields.address.lastName"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" offset-md="2">
          <v-text-field
            class="text-uppercase"
            v-model="address.address1"
            :rules="requiredAndLength"
            :counter="100"
            :label="text.fields.address.address1"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            class="text-uppercase"
            v-model="address.address2"
            :rules="lengthRules"
            :counter="100"
            :label="text.fields.address.address2"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="4" offset-md="2">
          <v-text-field
            class="text-uppercase"
            v-model="address.zip"
            :rules="requiredAndLength"
            :counter="100"
            :label="text.fields.address.zip"
            required
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            class="text-uppercase"
            v-model="address.city"
            :rules="requiredAndLength"
            :counter="100"
            :label="text.fields.address.city"
            required
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="8" offset-md="2"
               v-if="$store.state.user"
        >
          <v-checkbox
            v-model="address.saveAsDefault"
            :label="text.fields.saveAsDefault"
          ></v-checkbox>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { translations } from '@/lang/translations';
import { state } from '@/store';

export default {
  name: 'AddressForm',
  props: ['addressToEdit'],
  data() {
    return {
      valid: false,
    };
  },
  methods: {
    validate() {
      if (this.$refs.form) {
        this.$refs.form.validate();
        if (this.valid) {
          this.$emit('formData', this.address);
        }
      }
    },
  },
  computed: {
    address() {
      if (!this.addressToEdit) {
        return {
          firstName: null,
          lastName: null,
          address1: null,
          address2: null,
          zip: null,
          city: null,
          country: null,
          saveAsDefault: false,
        };
      }
      return {
        id: this.addressToEdit.id,
        firstName: this.addressToEdit.first_name,
        lastName: this.addressToEdit.last_name,
        address1: this.addressToEdit.address_1,
        address2: this.addressToEdit.address_2,
        zip: this.addressToEdit.zip,
        city: this.addressToEdit.city,
        country: null,
        saveAsDefault: this.addressToEdit.default,
      };
    },
    text() {
      return translations[state.language];
    },
    requiredAndLength() {
      return this.requiredRules.concat(this.lengthRules);
    },
    requiredRules() {
      return [
        (v) => !!v || this.text.validation.fieldIsRequired,
      ];
    },
    lengthRules() {
      return [
        (v) => ((v && v.length <= 100) || !v) || `${this.text.validation.maxCharactes}: 100`,
      ];
    },
    emailRules() {
      return [
        (v) => !!v || this.text.validation.fieldIsRequired,
        (v) => /.+@.+\..+/.test(v) || this.text.validation.emailNotValid,
      ];
    },
  },
};
</script>

<style scoped>

</style>
